import {ApolloLink} from '@apollo/client';

const removeTypename = (obj: any): any => {
    if (obj === null || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) return obj.map(removeTypename);

    const {__typename, ...rest} = obj;
    return Object.keys(rest).reduce(
        (acc, key) => {
            acc[key] = removeTypename(rest[key]);
            return acc;
        },
        {} as Record<string, any>,
    );
};

export const removeTypenameLink = new ApolloLink((operation, forward) => {
    return forward(operation).map(response => {
        if (response.data) {
            response.data = removeTypename(response.data);
        }
        return response;
    });
});
